
import { Component, Emit } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { ResetPasswordFormData } from '@/model/ResetPassword';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import { mixins } from 'vue-class-component';
import passwordValidations from '@/mixins/validations/password-validation';
import FormInput from '@/components/form/FormInput.vue';

@Component({
    components: {
        FormInput,
    },
})
export default class ResetPasswordForm extends mixins(FormValidationMixin) {
    formData = {
        password: '',
        passwordAgain: '',
    } as ResetPasswordFormData;

    submitted = false;

    @Validations()
    validations = {
        formData: {
            ...passwordValidations,
        },
    };

    @Emit()
    submit(): ResetPasswordFormData {
        return this.formData;
    }

    onSubmit(): void {
        this.submitted = true;

        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
}
